function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#6E6F80",
  fillRule: "evenodd",
  d: "M2.39015999,2.39015999 C5.57703998,-0.796719997 10.7439933,-0.796719997 13.9308733,2.39015999 C16.8732421,5.33252872 17.0989934,9.96278711 14.6081272,13.1641603 L19.70123,18.2586408 C20.09959,18.6570008 20.09959,19.30287 19.70123,19.70123 C19.30287,20.09959 18.6570008,20.09959 18.2586408,19.70123 L13.1649746,14.6074935 C9.96357238,17.0990316 5.33277822,16.8734916 2.39015999,13.9308733 C-0.796719997,10.7439933 -0.796719997,5.57703998 2.39015999,2.39015999 Z M3.83274916,3.83274916 C1.44258917,6.22290915 1.44258917,10.0981242 3.83274916,12.4882842 C6.22290915,14.8784442 10.0981242,14.8784442 12.4882842,12.4882842 C14.8784442,10.0981242 14.8784442,6.22290915 12.4882842,3.83274916 C10.0981242,1.44258917 6.22290915,1.44258917 3.83274916,3.83274916 Z"
});

var SvgSearchIcon = function SvgSearchIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearchIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search-icon.bfb7337c.svg";
export { ForwardRef as ReactComponent };